export var getResultsCountText = function getResultsCountText(numberOfResults, resultsCountText) {
  return "".concat(numberOfResults, " ").concat(resultsCountText);
};